import { Invitation } from '@back-office/http';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { isPast, parseJSON } from 'date-fns';
import { observer } from 'mobx-react';
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import GcpBox from '../gcp-box';

export const buttomWithTimerStyle = makeStyles(
  (theme) => ({
    hidden: {
      visibility: 'hidden',
    },
    secondary: {
      color: theme.palette.common.azureRadiant,
      border: `1px solid ${theme.palette.common.azureRadiant}`,
      boxSizing: 'border-box',
      borderRadius: '20px',
      '&:hover, &:focus': {
        background: 'rgba(0, 122, 255, 0.1)',
      },
    },
    timer_box: {
      height: '42px',
      textAlign: 'center',
      padding: '5px',
    },
    timer_text: {
      bottom: '30px',
      fontSize: '11px',
      position: 'relative',
      color: '#257aff',
    },
    timer_icon: { color: '#257aff' },
  }),
  { name: 'buttomWithTimerStyle' }
);

interface TimerProps {
  email: string;
  enableTime: number;
  row: Invitation;
  handleOnClickResend: (invitation: Invitation) => void;
}

const ButtonWithTimer: FC<TimerProps> = observer((props) => {
  const { t } = useTranslation();
  const classes = buttomWithTimerStyle();
  const [enableTime, setEnableTime] = React.useState<number>(0);
  React.useEffect(() => {
    let intervalID: number;

    if (props.enableTime > 0) {
      setEnableTime(Math.round(props.enableTime));
      intervalID = window.setInterval(() => {
        setEnableTime((duration) => {
          if (duration <= 0) {
            clearInterval(intervalID);
          }
          return duration - 1;
        });
      }, 1000);
    }
    return () => clearInterval(intervalID);
  }, [props.enableTime]);

  return (
    <>
      <Button
        className={clsx(classes.secondary, {
          [classes.hidden]: isPast(parseJSON(props.row.expiredAt)),
        })}
        disabled={enableTime > 0}
        variant="outlined"
        onClick={() => props.handleOnClickResend(props.row)}
      >
        {t('invite_new_user.resend')}
      </Button>
      <GcpBox className={classes.timer_box} hidden={enableTime <= 0}>
        <CircularProgress
          className={classes.timer_icon}
          size={30}
          thickness={1}
          value={((props.enableTime - enableTime) * 100) / props.enableTime}
          variant="determinate"
        />
        <Typography className={classes.timer_text}>{enableTime}s</Typography>
      </GcpBox>
    </>
  );
});
export default memo(ButtonWithTimer);
